import React from 'react'
import { Box, Td, Tr, Tbody, TableContainer, Table, Thead, Th, Text } from '@chakra-ui/react'
import moment from 'moment'

export default function TopCredits({ data }) {
    return (
        <Box mt={1} className='custom_table_wrapper report-table'>
            <TableContainer>
                <Table variant="striped">
                    <Thead>
                        <Tr>
                            <Th>Date</Th>
                            <Th>Transaction</Th>
                            <Th>Credit</Th>
                            <Th>Balance</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data?.map((item, index) => {
                            return (
                                <Tr key={index}>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Date ? moment(item.Date).format('DD/MM/YYYY'): ''}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Transaction}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">₹{item.Credit}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">₹{item.Balance}</Text>
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    )
}
